import React, {useState} from 'react';
import PageHeader from "../../components/PageHeader";
import {Link} from "react-router-dom";
import DataTable from "react-data-table-component";
import {customTableStyles} from "../../utils";
import {Button} from "react-bootstrap";

const AlertPage = () => {
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Alert 1 Date',
            selector: row => row.alert1Date,
            sortable: true,
        },
        {
            name: 'Alert 2 Date',
            selector: row => row.alert2Date,
            sortable: true,
        },
        {
            name: 'Alert 3 Date',
            selector: row => row.alert3Date,
            sortable: true,
        }
    ];
    const data = [
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        // Additional data entries...
    ];
    
    return (
        <>
            <PageHeader name="Driver Alerts "/>
            <div className="main-container container-fluid">
                {" "}
                {/* Start::row-1 */}
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card custom-card">
                            <div className="card-header w-100">
                                <div className="row w-100 m-0 justify-content-between">
                                    
                                    <div className="col-lg-3 col-5 p-0">
                                        <div className="input-group m-0">
                                            <span
                                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                                <i className="ri-search-line"/>
                                            </span>
                                            <input
                                                className="form-control" type="text" placeholder="Search Here..."
                                                aria-describedby="basic-addon1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    customStyles={customTableStyles}
                                    pagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            
        </>
    );
};

export default AlertPage;